import { DOCUMENTS } from '../reducers/types';
import { createAction } from './common';

export const setDocumentsList = createAction(DOCUMENTS.SET_DOCUMENTS);
